import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SafetySummary, SafetyTrendPoint, SafetyEventItem, SafetyEventsQueryParams } from '@app/core/api/safety-analytics';
import { AnalyticsQueryParams, AnalyticsTrendQueryParams } from '@app/core/api/analytics-shared';

export const SafetyAnalyticsActions = createActionGroup({
  source: 'Safety Analytics',
  events: {
    // Load summary
    'Load Summary': props<{ params: AnalyticsQueryParams }>(),
    'Load Summary Success': props<{ summary: SafetySummary }>(),
    'Load Summary Failure': props<{ error: string }>(),

    // Load trend
    'Load Trend': props<{ params: AnalyticsTrendQueryParams }>(),
    'Load Trend Success': props<{ trend: SafetyTrendPoint[] }>(),
    'Load Trend Failure': props<{ error: string }>(),

    // Load events
    'Load Events': props<{ params: SafetyEventsQueryParams }>(),
    'Load Events Success': props<{ events: SafetyEventItem[], totalCount: number }>(),
    'Load Events Failure': props<{ error: string }>(),

    // Clear state (on logout or page destroy)
    'Clear Safety Analytics State': emptyProps(),
  }
});
